export interface BackgroundGradientStop {
  color: string;
  position: number;
}

export interface BackgroundConfig {
  mode: 'solid' | 'gradient';
  solidColor?: string | null;
  gradient?: {
    angle: number;
    stops: BackgroundGradientStop[];
  } | null;
}

export interface ShopCompanyTheme {
  useParentTheme?: boolean | null;
  shopFavicon?: string | null;
  shopLogoWhite?: string | null;
  shopLogoLarge?: string | null;
  shopLogoSmall?: string | null;
  companyBanner?: string | null;
  shopLogoMainColor?: string | null;
  shopLogoMainColorLight?: string | null;
  shopLogoMainColorDark?: string | null;
  shopLogoMainColorTitleActive?: string | null;
  shopLogoMainColorTitlePlaceholder?: string | null;
  headerBackground?: BackgroundConfig | null;
  footerBackground?: BackgroundConfig | null;
  shopFontFamily1?: string | null;
  shopFontFamily2?: string | null;
  showSearchBar?: boolean | null;
  showAuthButtons?: boolean | null;
  showRegisterButtons?: boolean | null;
  showCart?: boolean | null;
  languageSelectorPosition?: 'navbar' | 'footer' | null;
}

export interface ShopCompany extends ShopCompanyTheme {
  shopCompanyId: number;
  shopId: number;
  companyName: string;
  companyLegalName: string;
  companyPhone: string;
  companyWebsiteUrl: string;
  status: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface ShopCompanyPayload {
  companyName?: string;
  companyLegalName?: string;
  companyPhone?: string;
  companyWebsiteUrl?: string;
  status?: number;
}

export type ShopCompanyThemePatch = Partial<ShopCompanyTheme>;

export interface ShopCompanyThemeFormChanges extends ShopCompanyThemePatch {
  useParentTheme: boolean;
}

export interface ShopCompanyUpdatePayload {
  shopCompanyId: number;
  shopId: number;
  companyName: string;
  companyLegalName: string;
  companyPhone: string;
  companyWebsiteUrl: string;
  status: number;
  useParentTheme: boolean;
  shopFavicon: string | null;
  shopLogoWhite: string | null;
  shopLogoLarge: string | null;
  shopLogoSmall: string | null;
  companyBanner: string | null;
  shopLogoMainColor: string | null;
  shopLogoMainColorLight: string | null;
  shopLogoMainColorDark: string | null;
  shopLogoMainColorTitleActive: string | null;
  shopLogoMainColorTitlePlaceholder: string | null;
  headerBackground: BackgroundConfig | null;
  footerBackground: BackgroundConfig | null;
  shopFontFamily1: string | null;
  shopFontFamily2: string | null;
  showSearchBar: boolean | null;
  showAuthButtons: boolean | null;
  showRegisterButtons: boolean | null;
  showCart: boolean | null;
  languageSelectorPosition: 'navbar' | 'footer' | null;
}

export function extractShopCompanies(response: any): ShopCompany[] {
  let source = response;

  if (typeof source?.body === 'string') {
    try {
      source = JSON.parse(source.body);
    } catch {
      source = response;
    }
  }

  const candidates = [
    source?.data?.shopCompanies,
    source?.data?.shopCompany,
    source?.data?.companies,
    source?.data?.items,
    source?.shopCompanies,
    source?.shopCompany,
    source?.companies,
    source?.items,
    source?.data,
    source,
  ];
  const companies = candidates.find((candidate) => Array.isArray(candidate));

  if (!companies) {
    return [];
  }

  return companies
    .map((company: any) => ({
      ...company,
      shopCompanyId: Number(company.shopCompanyId),
      shopId: Number(company.shopId),
      status:
        company.status === undefined || company.status === null
          ? 1
          : Number(company.status),
    }))
    .filter((company: ShopCompany) => Number.isFinite(company.shopCompanyId));
}
